(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[132],{

/***/ 7132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ CardPlant; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./app/hooks/usePlanteeUser.ts
var usePlanteeUser = __webpack_require__(4481);
// EXTERNAL MODULE: ./app/components/Buttons.tsx
var Buttons = __webpack_require__(2405);
// EXTERNAL MODULE: ./app/components/CardPlant.module.sass
var CardPlant_module = __webpack_require__(9419);
var CardPlant_module_default = /*#__PURE__*/__webpack_require__.n(CardPlant_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./app/components/CardPlantCarousel.module.sass
var CardPlantCarousel_module = __webpack_require__(5180);
var CardPlantCarousel_module_default = /*#__PURE__*/__webpack_require__.n(CardPlantCarousel_module);
;// CONCATENATED MODULE: ./app/components/CardPlantCarousel.tsx





const CardPlantCarousel = (param)=>{
    let { images  } = param;
    const [isActiveIndex, setActiveIndex] = (0,react.useState)(0);
    const [itemWidth, setItemWidth] = (0,react.useState)(0);
    const itemRef = (0,react.useRef)(null);
    const itemsRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!itemRef.current || !itemsRef.current) {
            return;
        }
        setItemWidth(itemRef.current.getBoundingClientRect().width);
    }, [
        images.length,
        itemWidth
    ]);
    const srollToItem = (0,react.useCallback)((index)=>{
        if (!itemsRef.current || !itemRef.current) {
            return;
        }
        let leftPos = 0;
        leftPos !== itemWidth * index ? leftPos = itemWidth * index : leftPos;
        itemsRef.current.scrollTo({
            left: leftPos,
            behavior: "smooth"
        });
        setActiveIndex(index);
    }, [
        itemWidth
    ]);
    const handleScroll = (0,react.useCallback)((event)=>setActiveIndex(Math.floor(event.currentTarget.scrollLeft / itemWidth)), [
        itemWidth
    ]);
    var _item_alt, _ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CardPlantCarousel_module_default()).images,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CardPlantCarousel_module_default()).imagesIn,
                ref: itemsRef,
                onScroll: handleScroll,
                children: images.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardPlantCarousel_module_default()).image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CardPlantCarousel_module_default()).imageIn,
                            ref: itemRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.url,
                                layout: "fill",
                                objectFit: "cover",
                                alt: (_ref = (_item_alt = item.alt) !== null && _item_alt !== void 0 ? _item_alt : item.description) !== null && _ref !== void 0 ? _ref : "",
                                placeholder: "blur",
                                blurDataURL: item.url
                            })
                        })
                    }, String(item.id)))
            }),
            images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CardPlantCarousel_module_default()).pagination,
                children: images.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)((CardPlantCarousel_module_default()).paginationBullet, index === isActiveIndex && (CardPlantCarousel_module_default()).is_active),
                        "aria-label": "Bullet",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            srollToItem(index);
                        }
                    }, String(item.id)))
            })
        ]
    });
};

// EXTERNAL MODULE: ./app/components/Likes.tsx
var Likes = __webpack_require__(4119);
// EXTERNAL MODULE: ./app/components/StatusBadge.tsx
var StatusBadge = __webpack_require__(6118);
// EXTERNAL MODULE: ./app/components/UserBadge.tsx + 3 modules
var UserBadge = __webpack_require__(8645);
;// CONCATENATED MODULE: ./app/components/CardPlant.tsx











const CardPlant = (param)=>{
    let { link , images , title , status , likes , user , plantProfile , isUserProfilePage  } = param;
    var _plantProfile_author;
    const [settingsOpen, setSettingsOpen] = react.useState(false);
    const plantee = (0,usePlanteeUser/* usePlanteeUser */.e)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CardPlant_module_default()).wrapper,
        children: [
            status && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CardPlant_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardPlant_module_default()).status,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusBadge/* StatusBadge */.O, {
                            status: status
                        })
                    }),
                    (plantProfile === null || plantProfile === void 0 ? void 0 : (_plantProfile_author = plantProfile.author) === null || _plantProfile_author === void 0 ? void 0 : _plantProfile_author.id) === (user === null || user === void 0 ? void 0 : user.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardPlant_module_default()).settings,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: (CardPlant_module_default()).settingsButton,
                            "aria-label": "card settings",
                            onClick: ()=>{
                                setSettingsOpen((old)=>!old);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CardPlant_module_default()).settingsButtonCircle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CardPlant_module_default()).settingsButtonCircle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (CardPlant_module_default()).settingsButtonCircle
                                })
                            ]
                        })
                    })
                ]
            }),
            settingsOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (CardPlant_module_default()).menu,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                            size: 3,
                            type: "button",
                            fontSize: "small",
                            fill: "red600",
                            onClick: (e)=>{
                                e.stopPropagation();
                                if (confirm("Do you really want to delete this Plant profile?")) {
                                    plantee.auth.removeProfile.mutateAsync({
                                        profileId: String(plantProfile === null || plantProfile === void 0 ? void 0 : plantProfile.id)
                                    });
                                    router.reload();
                                }
                            },
                            children: "Delete"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* Button */.z, {
                            size: 3,
                            type: "link",
                            fontSize: "small",
                            fill: "groundBlack",
                            href: "/create?id=".concat(plantProfile === null || plantProfile === void 0 ? void 0 : plantProfile.id, "&update=true"),
                            children: "Edit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CardPlant_module_default()).body,
                children: [
                    likes !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CardPlant_module_default()).likes,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Likes/* Likes */.d, {
                            isActive: isUserProfilePage,
                            heartColor: isUserProfilePage ? "red" : "default",
                            count: likes,
                            isBackground: true,
                            plantProfile: plantProfile
                        })
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPlantCarousel, {
                            images: images
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CardPlant_module_default()).content,
                        children: [
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (CardPlant_module_default()).contentTitle,
                                    children: title
                                })
                            }),
                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/author/".concat(user.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CardPlant_module_default()).contentUser,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBadge/* UserBadge */.s, {
                                        ...user
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 4119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Likes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var _hooks_usePlanteeUser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4481);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var _Likes_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6349);
/* harmony import */ var _Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4__);





const Likes = (param)=>{
    let { count =0 , isBackground , isNotButton , isActive , heartColor , plantProfile  } = param;
    var _plantee_auth_me_data, _plantee_auth_me_data_user, _plantee_auth_likeProfile_data, _plantee_auth_likeProfile_data1;
    const plantee = (0,_hooks_usePlanteeUser__WEBPACK_IMPORTED_MODULE_1__/* .usePlanteeUser */ .e)();
    const likeCount = plantProfile ? plantProfile.paginateLikedByUser.pageInfo.totalCount : 0;
    const likedByMe = plantProfile && ((_plantee_auth_me_data = plantee.auth.me.data) === null || _plantee_auth_me_data === void 0 ? void 0 : (_plantee_auth_me_data_user = _plantee_auth_me_data.user) === null || _plantee_auth_me_data_user === void 0 ? void 0 : _plantee_auth_me_data_user.id) ? plantProfile.likedByUser.map((item)=>item.id).includes(plantee.auth.me.data.user.id) : false;
    var _plantee_auth_likeProfile_data_likeCount, _plantee_auth_likeProfile_data_likedByMe;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wrapper), isBackground && (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().is_background)),
        children: isNotButton || !plantProfile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().notButton),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LikesContent, {
                count: count,
                isActive: isActive,
                heartColor: heartColor
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().button),
            onClick: (e)=>{
                var _plantee_auth_likeProfile_data;
                e.stopPropagation();
                var _plantee_auth_likeProfile_data_likedByMe;
                plantee.auth.likeProfile.mutateAsync({
                    profileId: String(plantProfile.id),
                    dislike: (_plantee_auth_likeProfile_data_likedByMe = (_plantee_auth_likeProfile_data = plantee.auth.likeProfile.data) === null || _plantee_auth_likeProfile_data === void 0 ? void 0 : _plantee_auth_likeProfile_data.likedByMe) !== null && _plantee_auth_likeProfile_data_likedByMe !== void 0 ? _plantee_auth_likeProfile_data_likedByMe : likedByMe
                });
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LikesContent, {
                count: (_plantee_auth_likeProfile_data_likeCount = (_plantee_auth_likeProfile_data = plantee.auth.likeProfile.data) === null || _plantee_auth_likeProfile_data === void 0 ? void 0 : _plantee_auth_likeProfile_data.likeCount) !== null && _plantee_auth_likeProfile_data_likeCount !== void 0 ? _plantee_auth_likeProfile_data_likeCount : likeCount,
                isActive: (_plantee_auth_likeProfile_data_likedByMe = (_plantee_auth_likeProfile_data1 = plantee.auth.likeProfile.data) === null || _plantee_auth_likeProfile_data1 === void 0 ? void 0 : _plantee_auth_likeProfile_data1.likedByMe) !== null && _plantee_auth_likeProfile_data_likedByMe !== void 0 ? _plantee_auth_likeProfile_data_likedByMe : likedByMe,
                heartColor: heartColor
            })
        })
    });
};
const LikesContent = (param)=>{
    let { count , isActive , heartColor  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().icon), isActive && (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().is_active), (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_color_".concat(heartColor)]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
                        name: "heart"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().is_hovered),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
                            name: "heartFilled"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Likes_module_sass__WEBPACK_IMPORTED_MODULE_4___default().count),
                children: count
            })
        ]
    });
};


/***/ }),

/***/ 6118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StatusBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5567);
/* harmony import */ var _StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2__);




const StatusBadge = (param)=>{
    let { status , label  } = param;
    const icon = status === "rejected" ? "reject" : status === "published" ? "success" : status;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2___default().main), (_StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2___default())["is_".concat(status)]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2___default().icon),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .J, {
                        name: icon
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_StatusBadge_module_sass__WEBPACK_IMPORTED_MODULE_2___default().label),
                    children: label !== null && label !== void 0 ? label : status[0].toUpperCase() + status.substring(1)
                })
            ]
        })
    });
};


/***/ }),

/***/ 8645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ UserBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./generated/content.ts
var content = __webpack_require__(1360);
;// CONCATENATED MODULE: ./app/utils/assertDefined.ts
function assertDefined(value) {
    if (value === undefined || value === null) {
        throw new Error("value should be defined");
    }
}

;// CONCATENATED MODULE: ./app/utils/assertNever.ts
const assertNever = (_)=>{
    throw new Error(JSON.stringify(_));
};

;// CONCATENATED MODULE: ./app/components/ContemberLink.tsx





const ContemberLink = (param)=>{
    let { link: { type , externalLink , internalLink  } , children , className  } = param;
    if (type === content/* LinkType.internal */.Un.internal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberInternalLink, {
            link: internalLink,
            className: className,
            children: children
        });
    } else if (type === content/* LinkType.external */.Un.external) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: externalLink !== null && externalLink !== void 0 ? externalLink : "#",
            className: className,
            children: children
        });
    } else {
        return assertNever(type);
    }
};
const ContemberInternalLink = (param)=>{
    let { link , children , className  } = param;
    assertDefined(link);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link.url,
        className: className,
        children: children
    });
};

// EXTERNAL MODULE: ./app/components/UserBadge.module.sass
var UserBadge_module = __webpack_require__(9213);
var UserBadge_module_default = /*#__PURE__*/__webpack_require__.n(UserBadge_module);
;// CONCATENATED MODULE: ./app/components/UserBadge.tsx





const UserBadge = (param)=>{
    let { link , image , name , size ="small" , isHighlighted  } = param;
    var _image_alt, _ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((UserBadge_module_default()).wrapper, size && (UserBadge_module_default())["is_size_".concat(size)], isHighlighted && (UserBadge_module_default()).is_highlighted),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (UserBadge_module_default()).label,
                children: "By"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBadgeLink, {
                link: link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (UserBadge_module_default()).main,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (UserBadge_module_default()).image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (UserBadge_module_default()).imageIn,
                                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image.url,
                                    layout: "fill",
                                    objectFit: "cover",
                                    alt: (_ref = (_image_alt = image.alt) !== null && _image_alt !== void 0 ? _image_alt : image.description) !== null && _ref !== void 0 ? _ref : "",
                                    sizes: "30px",
                                    placeholder: "blur",
                                    blurDataURL: image.url
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (UserBadge_module_default()).name,
                            children: name
                        })
                    ]
                })
            })
        ]
    });
};
const UserBadgeLink = (param)=>{
    let { link , children  } = param;
    if (link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContemberLink, {
            link: link,
            className: (UserBadge_module_default()).link,
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
};


/***/ }),

/***/ 9419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardPlant_wrapper__sHHXe","menu":"CardPlant_menu__CyFR2","link":"CardPlant_link__ALejx","header":"CardPlant_header__PvPw0","settings":"CardPlant_settings__YS_Bb","settingsButton":"CardPlant_settingsButton__08nCc","settingsButtonCircle":"CardPlant_settingsButtonCircle__XMj82","body":"CardPlant_body__Rh7at","content":"CardPlant_content___gWVW","contentTitle":"CardPlant_contentTitle__cLJlu","contentUser":"CardPlant_contentUser__UNdZm","likes":"CardPlant_likes__YKXDt"};

/***/ }),

/***/ 5180:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"images":"CardPlantCarousel_images__REVER","imagesIn":"CardPlantCarousel_imagesIn__s7B9G","image":"CardPlantCarousel_image__icvAt","imageIn":"CardPlantCarousel_imageIn__H73ci","pagination":"CardPlantCarousel_pagination__e_LT_","paginationBullet":"CardPlantCarousel_paginationBullet__Oq9Xq","is_active":"CardPlantCarousel_is_active__zGbGB"};

/***/ }),

/***/ 6349:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Likes_wrapper__lzDQd","is_background":"Likes_is_background__GNGC4","button":"Likes_button__xmtgZ","icon":"Likes_icon__Mt5Um","count":"Likes_count__p474x","notButton":"Likes_notButton__dbtQX","is_hovered":"Likes_is_hovered__k5RUw","is_active":"Likes_is_active__WkhJ6","is_color_red":"Likes_is_color_red__eje8Z"};

/***/ }),

/***/ 5567:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatusBadge_wrapper__32cRi","main":"StatusBadge_main__smvgL","is_rejected":"StatusBadge_is_rejected__a8VDf","is_pending":"StatusBadge_is_pending__QvZC6","is_published":"StatusBadge_is_published__MFCVr","icon":"StatusBadge_icon__0Qehj","label":"StatusBadge_label__VFuUM"};

/***/ }),

/***/ 9213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserBadge_wrapper__eWQod","is_size_medium":"UserBadge_is_size_medium__0fe00","image":"UserBadge_image__1__tk","is_highlighted":"UserBadge_is_highlighted__z3TxT","name":"UserBadge_name__6jWzb","link":"UserBadge_link___TFWp","is_size_big":"UserBadge_is_size_big__KcZT_","label":"UserBadge_label__Hba5t","imageIn":"UserBadge_imageIn___tK_5","main":"UserBadge_main__camLU"};

/***/ })

}]);